import { numberArrayParser } from '../inboundParsers';
export const UPDATE_POT_AMOUNTS_INBOUND_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'potAmounts', parser: numberArrayParser }]
};
